import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './style.module.css';
import { CircularProgress } from '@mui/material';
import BackAndNextButton from 'layouts/RegistrationLayoutNew/Buttons/BackAndNextButton';

const SubmitScreen = ({
  userExist,
  existingUserNewCard,
  handleConvertPhotoIntoBinary,
  userPersonalInfo,
  termsAccept,
  setTermsAccept,
  emailAddress,
  newUserInfo,
  setTitle,
  titles,
  setSection,
  setTab,
  selectedClub,
  selectedPlan,
  card,
  createNewUser,
  onNext,
  onBack,
  isMobile,
  userExistenceData,
  updateExistingUser,
  seteditDetailsOnNext,
  editedCardInfo,
  photo,
  paymentDetails,
  state,
  resetObjectState,
  updatedUserDetails,
  referralPerson,
  isRequestingNewUser,
  isRequestingUploadPhoto,
  isRequestingUpdateExistingUser,
  utmParams,
  updateUtmInfo,
  updateOlsTracking,
  trackingId,
  title,
  setError,
  getSubmitFailureData,
  submitFailureData,
  loadingRetryUser,
  isCreateUserRetryFailed,
  retryUserData,
  getMembershipText,
  membershipTextData,
  activePlanTab,
  uploadSignData,
  ipAddress,
  signaturedImage,
  selectedPlanName,
  loadMembershipReceiptPDF,
}) => {
  const [isLoading, setisLoading] = useState(false);
  const parts = userPersonalInfo?.birthday?.split('/');
  const [month, day, year] = parts;
  const history = useHistory();
  const { location } = useParams();

  var userDetailsForCreation = {
    onlyPreview: false,
    gender: userPersonalInfo?.gender,
    firstName: userPersonalInfo?.firstName,
    lastName: userPersonalInfo?.lastName,
    dateOfBirth: `${year}-${month}-${day}`,
    email: emailAddress,
    phoneNumber: parseInt(userPersonalInfo?.phone?.replace(/[^0-9]/g, '')),
    contactAddressLine1: userPersonalInfo?.address,
    contactCity: userPersonalInfo?.city,
    contactState: userPersonalInfo?.state,
    contactZip: userPersonalInfo?.zipCode,
    emergencyContactName: userPersonalInfo?.emergencyContactName,
    emergencyContactPhone: parseInt(
      userPersonalInfo?.emergencyContactPhone?.replace(/[^0-9]/g, '')
    ),
    homeClubId: parseInt(selectedClub?.clubautomationclubidC),
    membershipId: selectedPlan?.id,
    paymentMethod: 'credit card',
    eftAuthAccept: true,
    signature: userPersonalInfo?.firstName + ' ' + userPersonalInfo?.lastName,
    billingAddressLine1: userPersonalInfo?.address,
    billingCity: userPersonalInfo?.city,
    billingState: userPersonalInfo?.state,
    billingZip: userPersonalInfo?.zipCode,
    memberPortalPassword: 'A9cebc648-2e9e-4c6d-8c7a-6ea5ff36d',
    termsAccept: true,
    waiverReleaseAccept: true,
    billingName: userPersonalInfo?.firstName + ' ' + userPersonalInfo?.lastName,
    i4goUniqueId: card?.i4goUniqueId,
    maskedCardNumber: card?.cardNumber,
    cardExpirationMonth: parseInt(card?.cardExpirationMonth),
    cardExpirationYear: parseInt(card?.cardExpirationYear),
    referredByCaId: Object.keys(referralPerson).length !== 0 ? referralPerson?.caID : '',
    referredByName: Object.keys(referralPerson).length !== 0 ? referralPerson.name : '',
    hubspotreferralbyid:
      Object.keys(referralPerson).length !== 0 ? referralPerson.referralId : '',
  };

  var userDetailsForUpdation = {
    onlyPreview: true,
    gender: userPersonalInfo?.gender,
    caID: JSON.stringify(userExistenceData?.data?.data),
    firstName: userPersonalInfo?.firstName,
    lastName: userPersonalInfo?.lastName,
    dateOfBirth: `${year}-${month}-${day}`,
    email: emailAddress,
    cellPhone: parseInt(userPersonalInfo?.phone?.replace(/[^0-9]/g, '')),
    contactAddressLine1: userPersonalInfo?.address,
    contactCity: userPersonalInfo?.city,
    contactState: userPersonalInfo?.state,
    contactZip: userPersonalInfo?.zipCode,
    emergencyContactName: userPersonalInfo?.emergencyContactName,
    emergencyContactPhone: parseInt(
      userPersonalInfo?.emergencyContactPhone?.replace(/[^0-9]/g, '')
    ),
    homeClubId: parseInt(selectedClub?.clubautomationclubidC),
    membershipId: selectedPlan?.id,
    paymentMethod: 'credit card',
    eftAuthAccept: true,
    signature: card?.billingName,
    billingAddressLine1: userPersonalInfo?.address,
    billingCity: userPersonalInfo?.city,
    billingState: userPersonalInfo?.state,
    billingZip: userPersonalInfo?.zipCode,
    memberPortalPassword: 'A9cebc648-2e9e-4c6d-8c7a-6ea5ff36d',
    termsAccept: true,
    waiverReleaseAccept: true,
    billingName: userPersonalInfo?.firstName + ' ' + userPersonalInfo?.lastName,
    i4goUniqueId: card?.i4goUniqueId,
    maskedCardNumber: card?.cardNumber,
    cardExpirationMonth: parseInt(card?.cardExpirationMonth),
    cardExpirationYear: parseInt(card?.cardExpirationYear),
    paymentMethodId:
      Object.keys(editedCardInfo).length === 0
        ? JSON.stringify(existingUserNewCard?.data)
        : editedCardInfo?.data,
    referredByCaId: Object.keys(referralPerson).length !== 0 ? referralPerson?.caID : '',
    referredByName: Object.keys(referralPerson).length !== 0 ? referralPerson.name : '',
    hubspotreferralbyid:
      Object.keys(referralPerson).length !== 0 ? referralPerson.referralId : '',
  };

  const payload = {
    session: trackingId,
    email: emailAddress,
    currentPage: '',
    data: null,
    isFormerMember: userExist,
    isReferral: Object.keys(referralPerson).length !== 0,
    referrerName: Object.keys(referralPerson).length !== 0 ? referralPerson.name : null,
    referrerCaid: Object.keys(referralPerson).length !== 0 ? referralPerson?.caID : null,
  };

  const handleSubmitPayment = async () => {
    if (!userExist) {
      setisLoading(true);
      const blob = handleConvertPhotoIntoBinary(photo);
      const formData = new FormData();
      formData.append('profilePicture', blob, 'photo.jpg');
      let data = {
        user: userDetailsForCreation,
        isPhotoUpload: true,
        photo: formData,
      };
      await createNewUser(data);
    } else if (userExist) {
      setisLoading(true);
      updateExistingUser(userDetailsForUpdation);
    }
    payload.currentPage = title;
    payload.data = !userExist
      ? JSON.stringify({ ...userDetailsForCreation })
      : JSON.stringify({ ...userDetailsForUpdation });

    updateOlsTracking(payload);
  };

  useEffect(() => {
    if (loadingRetryUser) {
      setError('Hang tight! We are still processing your request.');
    } else if (!loadingRetryUser && isCreateUserRetryFailed) {
      handleApiError(submitFailureData);
    }
  }, [loadingRetryUser, isCreateUserRetryFailed]);

  const handleApiError = data => {
    const { message, messageUrl } = data;
    setError(
      <>
        {message.split(messageUrl)[0]}
        <a
          href={messageUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'white',
            fontSize: '14px',
            fontFamily: 'var(--font-primary-regular)',
            fontWeight: 500,
            textDecoration: 'underline',
          }}
        >
          FITNESS SF | Contact Us
        </a>
        {message.split(messageUrl)[1]}
      </>
    );
  };

  const handleBack = () => {
    resetObjectState('paymentDetails');
    setTermsAccept(false);
    onBack();
  };

  const uploadReceiptPDF = () => {
    const formData = new FormData();

    // Clone the original object and override the Email field
    const updatedDto = {
      ...updateOLSUserDto,
      Email: 'x5Tt34FB4Fzw1@gmail.com',
    };
    formData.append('documentId', 6);
    Object.keys(updatedDto).forEach(key => {
      formData.append(`updateOLSUserDto.${key}`, updatedDto[key]);
    });
    loadMembershipReceiptPDF(formData);
  };

  const handleEdit = (tab, section) => {
    setTab(tab);
    setSection(section);

    if (tab === 0 && section === 0) {
      seteditDetailsOnNext(0);
      setTitle(titles[0]);
      history.push('/');
      resetObjectState('userExistenceData');
    }

    if (tab === 2 && section === 2) {
      seteditDetailsOnNext(2);
      setTitle(titles[2]);
      resetObjectState('userExistenceData');
    }
    if (tab === 2 && section === 3) {
      seteditDetailsOnNext(3);
      setTitle(titles[3]);
    }
    if (tab === 1 && section === 1) {
      seteditDetailsOnNext(1);
      setTitle(titles[1]);
    }
    if (tab === 4 && section === 9) {
      seteditDetailsOnNext(9);
      setTitle(titles[8]);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    seteditDetailsOnNext(0);
    getSubmitFailureData();
    getMembershipText();
  }, []);

  const updateOLSUserDto = {
    OnlyPreview: true,
    Gender: userPersonalInfo?.gender,
    CaID: userExistenceData?.data?.data
      ? JSON.stringify(userExistenceData?.data?.data)
      : newUserInfo?.newUserData?.userId,
    FirstName: userPersonalInfo?.firstName,
    LastName: userPersonalInfo?.lastName,
    Email: 'x5Tt34FB4Fzw@gmail.com',
    CellPhone: parseInt(userPersonalInfo?.phone?.replace(/[^0-9]/g, '')),
    ContactAddressLine1: userPersonalInfo?.address,
    ContactCity: userPersonalInfo?.city,
    ContactState: userPersonalInfo?.state,
    ContactZip: parseInt(userPersonalInfo?.zipCode),
    EmergencyContactName: userPersonalInfo?.emergencyContactName,
    EmergencyContactPhone: parseInt(
      userPersonalInfo?.emergencyContactPhone?.replace(/[^0-9]/g, '')
    ),
    HomeClubId: parseInt(selectedClub?.clubautomationclubidC),
    MembershipId: selectedPlan?.id,
    MemberPortalPassword: 'A9cebc648-2e9e-4c6d-8c7a-6ea5ff36d',
    PaymentMethod: 'credit card',
    EftAuthAccept: true,
    Signature: userPersonalInfo?.firstName + ' ' + userPersonalInfo?.lastName,
    BillingAddressLine1: userPersonalInfo?.address,
    BillingCity: userPersonalInfo?.city,
    BillingState: userPersonalInfo?.state,
    BillingZip: parseInt(userPersonalInfo?.zipCode),
    TermsAccept: true,
    WaiverReleaseAccept: true,
    BillingName: userPersonalInfo?.firstName + ' ' + userPersonalInfo?.lastName,
    I4goUniqueId: card?.i4goUniqueId,
    MaskedCardNumber: card?.cardNumber,
    CardExpirationMonth: parseInt(card?.cardExpirationMonth),
    CardExpirationYear: parseInt(card?.cardExpirationYear),
    PaymentMethodId: '',
    ReferredByCaId: Object.keys(referralPerson).length !== 0 ? referralPerson?.caID : '',
    ReferredByName: Object.keys(referralPerson).length !== 0 ? referralPerson.name : '',
    hubspotreferralbyid:
      Object.keys(referralPerson).length !== 0 ? referralPerson.referralId : '',
  };

  useEffect(() => {
    const base64Data = signaturedImage?.replace(
      /^data:image\/(png|jpg|jpeg);base64,/,
      ''
    );
    const binaryString = window.atob(base64Data);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const signatureBlob = new Blob([bytes], { type: 'image/png' });

    const photoBlob = handleConvertPhotoIntoBinary(photo);

    const formData = new FormData();
    formData.append('documentId', activePlanTab === 'membership' ? 3 : 2);
    formData.append('useripaddress', ipAddress);
    formData.append('esignuser', signatureBlob, 'typed-signature.png');
    formData.append('userpic', photoBlob, 'photo.jpg');
    Object.keys(updateOLSUserDto).forEach(key => {
      formData.append(`updateOLSUserDto.${key}`, updateOLSUserDto[key]);
    });
    if (
      (!userExist && Object.keys(newUserInfo).length !== 0) ||
      (!userExist && Object.keys(retryUserData).length !== 0)
    ) {
      const updatedPaymentDetails =
        Object.keys(retryUserData).length !== 0
          ? { newUserData: paymentDetails.data }
          : newUserInfo;
      const caid =
        Object.keys(retryUserData).length !== 0
          ? retryUserData.data
          : newUserInfo?.newUserData?.userId;
      const data = {
        caid: caid,
        utmCampaign: utmParams.utmCampaign,
        utmContent: utmParams.utmContent,
        utmMedium: utmParams.utmMedium,
        utmSource: utmParams.utmSource,
        marketingInitialOnlinePayment: parseFloat(
          updatedPaymentDetails?.newUserData?.totalDue.replace('$', '')
        ),
        marketingMonthlyPayment: parseFloat(
          updatedPaymentDetails?.newUserData?.enrollmentFee.replace('$', '')
        ),
      };
      onNext();
      uploadSignData(formData);
      uploadReceiptPDF();
      payload.currentPage = 'Congratulation!';
      updateOlsTracking(payload);
      setTimeout(() => {
        updateUtmInfo(data);
      }, 3000);
      localStorage.setItem('payment', 'completed');
      history.push({
        pathname: `/${location}/payment-confirmation`,
        state: {
          paymentDetails: updatedPaymentDetails,
          selectedClub,
          activePlanTab,
          membershipTextData,
          selectedPlanName,
          isPolkGrandOpening: selectedPlan?.isPolkGrandOpening,
        },
      });
    }
    if (
      (userExist && Object.keys(updatedUserDetails).length !== 0) ||
      (userExist && Object.keys(retryUserData).length !== 0)
    ) {
      const updatedcaid =
        Object.keys(retryUserData).length !== 0
          ? userExistenceData?.data?.data
          : updatedUserDetails?.data?.userId;
      const data = {
        caid: updatedcaid,
        utmCampaign: utmParams.utmCampaign,
        utmContent: utmParams.utmContent,
        utmMedium: utmParams.utmMedium,
        utmSource: utmParams.utmSource,
        marketingInitialOnlinePayment: parseFloat(
          paymentDetails?.data?.totalDue.replace('$', '')
        ),
        marketingMonthlyPayment: parseFloat(
          paymentDetails?.data?.enrollmentFee.replace('$', '')
        ),
      };
      onNext();
      uploadSignData(formData);
      uploadReceiptPDF();
      payload.currentPage = 'Congratulation!';
      updateOlsTracking(payload);
      setTimeout(() => {
        updateUtmInfo(data);
      }, 3000);
      localStorage.setItem('payment', 'completed');
      history.push({
        pathname: `/${location}/payment-confirmation`,
        state: {
          paymentDetails,
          selectedClub,
          activePlanTab,
          membershipTextData,
          selectedPlanName,
          isPolkGrandOpening: selectedPlan?.isPolkGrandOpening,
          updatedcaid,
        },
      });
    }
  }, [newUserInfo, updatedUserDetails, retryUserData]);

  useEffect(() => {
    if (!userExist) {
      if (!isRequestingNewUser) {
        setisLoading(false);
      }
    } else {
      if (!isRequestingUpdateExistingUser) {
        setisLoading(false);
      }
    }
  }, [isRequestingNewUser, isRequestingUploadPhoto, isRequestingUpdateExistingUser]);

  return (
    <>
      {Object.keys(paymentDetails).length === 0 ? (
        <>
          <div className={styles.progressbarDiv}>
            <CircularProgress
              className={styles.circularProgress}
              style={{ color: '#fe5000' }}
            />
          </div>
        </>
      ) : (
        <>
          <div
            className={
              activePlanTab === 'membership'
                ? `${styles.wrapper} ${isMobile ? styles.mobile : ''}`
                : `${styles.passWrapper} ${isMobile ? styles.mobile : ''}`
            }
          >
            <div className={styles.row1}>
              <div className={`${styles.grid1} ${isMobile ? styles.mobile : ''}`}>
                <div className={styles.header}>
                  <p className={styles.mainHeading}>Location</p>
                  <button onClick={() => handleEdit(0, 0)} className={styles.editBtn}>
                    Edit
                  </button>
                </div>
                <p className={styles.mainContent}>FITNESS {selectedClub?.name}</p>
              </div>
              <div className={`${styles.grid1} ${isMobile ? styles.mobile : ''}`}>
                <div className={styles.header}>
                  <p className={styles.mainHeading}>Email Address</p>
                  <button onClick={() => handleEdit(2, 2)} className={styles.editBtn}>
                    Edit
                  </button>
                </div>
                <p className={styles.mainContent}>{emailAddress}</p>
              </div>
              <div
                className={`${styles.grid3} ${isMobile ? styles.mobile : ''}`}
                style={
                  activePlanTab === 'pass' && !isMobile ? { marginBottom: '25px' } : {}
                }
              >
                <div>
                  <div className={styles.header}>
                    <p className={styles.mainHeading}>Personal Info</p>
                    <button onClick={() => handleEdit(2, 3)} className={styles.editBtn}>
                      Edit
                    </button>
                  </div>
                  <div className={styles.PersonalContentWrapper}>
                    <p className={styles.contentHeading}>Full Name:</p>
                    <p className={styles.Personalcontent}>
                      {userPersonalInfo?.firstName + ' ' + userPersonalInfo?.lastName}
                    </p>
                  </div>
                  <div className={styles.PersonalContentWrapper}>
                    <p className={styles.contentHeading}>Phone Number:</p>
                    <p className={styles.Personalcontent}>{userPersonalInfo?.phone}</p>
                  </div>
                  <div className={styles.PersonalContentWrapper}>
                    <p className={styles.contentHeading}>Birthdate:</p>
                    <p className={styles.Personalcontent}>
                      {month + '-' + day + '-' + year}
                    </p>
                  </div>
                  <div className={styles.divider}></div>
                </div>
                <div className={styles.AddressWrapper}>
                  <p className={styles.addressHeading}>Home Address:</p>
                  <p className={styles.addressContent}>
                    {userPersonalInfo?.address + ' , ' + userPersonalInfo?.city + '.'}
                    <br />
                    {state + ' , ' + userPersonalInfo?.zipCode}
                  </p>
                </div>
              </div>
              {activePlanTab === 'membership' ? (
                <div className={`${styles.grid2} ${isMobile ? styles.mobile : ''}`}>
                  <div className={styles.header}>
                    <p className={styles.mainHeading}>Payment Info</p>
                    <button onClick={() => handleEdit(4, 9)} className={styles.editBtn}>
                      Edit
                    </button>
                  </div>
                  <p className={styles.mainContent}>
                    <span>{`**** **** **** ${card?.cardNumber?.slice(-4)}`}</span>
                  </p>
                  <p className={styles.expiration_date}>
                    Exp Date :{' '}
                    {card?.cardExpirationMonth + '/' + card?.cardExpirationYear}
                  </p>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className={activePlanTab === 'pass' ? styles.passRow : styles.row2}>
              {activePlanTab === 'pass' ? (
                <>
                  <div className={`${styles.grid2} ${isMobile ? styles.mobile : ''}`}>
                    <div className={styles.header}>
                      <p className={styles.mainHeading}>Payment Info</p>
                      <button onClick={() => handleEdit(4, 9)} className={styles.editBtn}>
                        Edit
                      </button>
                    </div>
                    <p className={styles.mainContent}>
                      <span>{`**** **** **** ${card?.cardNumber?.slice(-4)}`}</span>
                    </p>
                    <p className={styles.expiration_date}>
                      Exp Date :{' '}
                      {card?.cardExpirationMonth + '/' + card?.cardExpirationYear}
                    </p>
                  </div>
                  <div className={`${styles.passGrid4} ${isMobile ? styles.mobile : ''}`}>
                    <div>
                      <div className={styles.header}>
                        <p className={styles.mainHeading}>Membership Plan</p>
                        <button
                          onClick={() => handleEdit(1, 1)}
                          className={styles.editBtn}
                        >
                          Edit
                        </button>
                      </div>
                      <p
                        style={{ padding: ' 0px 0px 0px 30px' }}
                        className={styles.content}
                      >
                        {selectedPlanName}
                      </p>
                      <p className={styles.passDate}>
                        Valid through {paymentDetails?.data?.starting} -{' '}
                        {paymentDetails?.data?.ending}
                      </p>
                    </div>

                    {isMobile ? (
                      <div className={styles.divider} style={{ marginTop: '20px' }}></div>
                    ) : (
                      ''
                    )}

                    <div>
                      <div className={styles.totalAmtWrapper}>
                        <p
                          style={{
                            textDecoration: 'none',
                            padding: '0px 0px 10px 30px',
                            lineHeight: '50px',
                          }}
                          className={styles.mainHeading}
                        >
                          Due Today
                        </p>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                          }}
                        >
                          <p className={styles.totalAmtHeading}>Total</p>
                          <p className={styles.totalAmtContent}>
                            {paymentDetails?.data?.totalDue}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className={`${styles.grid4} ${isMobile ? styles.mobile : ''}`}>
                  <div>
                    <div className={styles.header}>
                      <p className={styles.mainHeading}>Membership Plan</p>
                      <button onClick={() => handleEdit(1, 1)} className={styles.editBtn}>
                        Edit
                      </button>
                    </div>
                    <p
                      style={{ padding: ' 0px 0px 0px 30px' }}
                      className={styles.content}
                    >
                      {selectedPlanName}
                    </p>
                    <p className={styles.passDate}>
                      Start Date: {paymentDetails?.data?.starting}
                    </p>
                    <div className={styles.header}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          fontWeight: 0,
                        }}
                      >
                        <p
                          style={{ textDecoration: 'none', lineHeight: '30px' }}
                          className={styles.mainHeading}
                        >
                          Monthly Dues
                        </p>
                        <p className={styles.text2}>
                          {membershipTextData?.monthlyDuesText}
                        </p>
                      </div>
                      <p style={{ marginTop: '7px' }} className={styles.text}>
                        {paymentDetails?.data?.enrollmentFee}
                      </p>
                    </div>
                    <div className={styles.membershipDivider}></div>
                  </div>

                  <div>
                    <div className={styles.totalAmtWrapper}>
                      <p
                        style={{
                          textDecoration: 'none',
                          padding: '0px 0px 0px 30px',
                          lineHeight: '70px',
                        }}
                        className={styles.mainHeading}
                      >
                        Due Today
                      </p>
                      <div className={styles.contentWrapper}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            fontWeight: 0,
                          }}
                        >
                          <p
                            style={{ textDecoration: 'none', lineHeight: '30px' }}
                            className={styles.contentHeading}
                          >
                            {selectedPlan?.isPolkGrandOpening
                              ? '1st month dues'
                              : 'Prorated 1st month dues'}
                          </p>
                          {!selectedPlan?.isPolkGrandOpening && (
                            <p className={styles.text2} style={{ paddingLeft: '30px' }}>
                              {membershipTextData?.proratedText}
                            </p>
                          )}
                        </div>
                        <p
                          style={{ marginTop: '7px', paddingRight: '30px' }}
                          className={styles.text}
                        >
                          {paymentDetails?.data?.membershipFee}
                        </p>
                      </div>
                      <div className={styles.contentWrapper}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            fontWeight: 0,
                          }}
                        >
                          <p
                            style={{ textDecoration: 'none', lineHeight: '30px' }}
                            className={styles.contentHeading}
                          >
                            Last month dues
                          </p>
                          <p className={styles.text2} style={{ paddingLeft: '30px' }}>
                            {membershipTextData?.lastMonthText}
                          </p>
                        </div>
                        <p
                          style={{ marginTop: '7px', paddingRight: '30px' }}
                          className={styles.text}
                        >
                          {paymentDetails?.data?.enrollmentFee}
                        </p>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}
                      >
                        <p className={styles.totalAmtHeading}>Total</p>
                        <p className={styles.totalAmtContent}>
                          {paymentDetails?.data?.totalDue}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.mainScroll} />
          <BackAndNextButton
            onBack={() => handleBack()}
            backButtonName="Back"
            nextButtonName={
              isLoading ? (
                <CircularProgress size={30} color="inherit" />
              ) : (
                'Submit Payment'
              )
            }
            nextButtonDisable={isCreateUserRetryFailed || isLoading}
            onNext={() => handleSubmitPayment()}
          />
        </>
      )}
    </>
  );
};

SubmitScreen.propTypes = {
  selectedClub: PropTypes.object.isRequired,
  selectedPlan: PropTypes.object.isRequired,
  card: PropTypes.object.isRequired,
  planInfo: PropTypes.object.isRequired,
  createUser: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  isRequesting: PropTypes.bool.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default SubmitScreen;
